import React from 'react';
import '../App.css';

import { Link } from 'react-router-dom';

class Navbar extends React.Component
{
	reloadWindow = () =>
	{
		window.ReinitializeWindow();
	}

	addLink = (label, link) =>
	{
		return (

			<Link
				onClick={this.reloadWindow()}
				className='navbar-link'
				to={link}
			>
				{label}
			</Link>
		)
	}

	closeBurgerMenu = () =>
	{
		window.CloseBurgerMenu();
	}

	revalidateBurgerMenu = () =>
	{
		window.RevalidateBurgerMenu();
	}

	render()
	{
		return (
			
			<div className='navbar'>
				
				<div className='navbar-logo-container'>

					<a href='/'>

						<img className='navbar-logo' src={require('../images/logo/logo.png')} />

					</a>

				</div>

				<div className='navbar-links-container'>

					{this.addLink("Home", "/")}
					{this.addLink("About", "/portfolio/about")}
					{this.addLink("Games", "/portfolio/games")}
					{this.addLink("Contact", "/portfolio/contact")}

				</div>

				<div className='navbar-burger-menu'>

					<input
						onClick={this.revalidateBurgerMenu}
						className='navbar-burger-toggle'
						type="checkbox" />

					<div className='navbar-burger-content'>

						<div className='navbar-burger-sticks-container'>

							<div className='navbar-burger-stick navbar-burger-top'></div>
							<div className='navbar-burger-stick navbar-burger-middle'></div>
							<div className='navbar-burger-stick navbar-burger-bottom'></div>

						</div>

						<div
							className='navbar-burger-links-container'
						>

							{this.addLink("Home", "/")}
							{this.addLink("About", "/portfolio/about")}
							{this.addLink("Games", "/portfolio/games")}
							{this.addLink("Contact", "/portfolio/contact")}

						</div>

					</div>

				</div>

			</div>

		);
	}
}

export default Navbar;